import * as React from 'react'

export default function withForwardRef<P>(
  WrappedComponent: React.ComponentType<P>,
) {
  return React.forwardRef((props: P, ref) => {
    return <WrappedComponent {...props} ref={ref} />
  })
}
